import { Button, Breadcrumb, BPanel, Table, Progress } from '@sketchpixy/rubix';
import { Link } from 'react-router';
import React from 'react';
import ReactDOM from 'react-dom';
import { Tracker } from 'meteor/tracker';
import Moment from 'react-moment';
import moment from 'moment';
import { Base64 } from 'meteor/base64';
import { HTTP } from 'meteor/http';
import { Meteor } from 'meteor/meteor';
import { Reactive } from '../common/Reactive.mixin.js';
import { GroupBillsPayments } from '../../collections/partners/group-bills-payments';

import { UserSchema } from '../../collections/users/users';
import MgfTableComponent from '../common/mgfTable';
import { GroupBillModal } from './components/GroupBillModal';

import { GroupBills } from '../../collections/partners/group-bills';

@Reactive({
	subscriptions: ["reservations-groupBills", "flights-type", "users", "group-bills"],
})
export default class GroupBillListPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			modal: {
				visible: false,
			}
		};

		props.ready.then(() => {
			Tracker.nonreactive(() => {
				this.setState({
					groupBills: GroupBills.find({}, {sort: {'id_facture':-1}}).fetch(),
				});
			});
		});
	}

	componentDidUpdate(prevProps, prevState) {
  	if(this.state.visible != prevState.visible) {
			this.setState({
				groupBills: GroupBills.find({}, {sort: {'id_facture':-1}}).fetch(),
			});
		}
	}

	openModal(event) {
		this.setState({
			visible: true,
			bill: GroupBills.findOne(event.target.id),
			payments: GroupBillsPayments.find({bill: event.target.id}).fetch()
		});
	}


	addPayment() {

		let payment = {
			'type': ReactDOM.findDOMNode(this.refs.type).value.trim(),
			'montant': ReactDOM.findDOMNode(this.refs.montant).value.trim(),
			'informations': ReactDOM.findDOMNode(this.refs.informations).value.trim(),
			'bill': this.props.bill._id
		};

		let that = this;
		Meteor.call('groupbills.payments.insert', payment, (function (err, _id) {
			if (err) {
				Messenger().post({
					message: "Erreur, " + err,
					type: "error"
				});
				return;
			}

			Messenger().post({
				message: "Le paiement a été enregistré.",
				type: "success"
			});

			that.props.onHide();
		}));
	}

	removePayment(event) {

		if(confirm('Êtes-vous sûr de vouloir supprimer ce paiement ?')) {

			let that = this;
			Meteor.call('groupbills.payments.remove', event.target.value, (function (err, _id) {
				if (err) {
					Messenger().post({
						message: "Erreur..." + err,
						type: "error"
					});
					return;
				}

				Messenger().post({
					message: "Le paiement a été supprimé.",
					type: "success"
				});

				that.props.onHide();
			}));

		}
	}

	render() {

	if(!this.state.groupBills) {
  		return (
				<Progress active value={100} />
  		);
  	}

		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						Factures groupées
					</Breadcrumb.Item>
					<Breadcrumb.Item>
						<Link to="/group-bills/add"><Button bsStyle="success">Créer</Button></Link>
					</Breadcrumb.Item>
				</Breadcrumb>

				{this.state.bill &&
				<GroupBillModal visible={this.state.visible} bill={this.state.bill} payments={this.state.payments} addPayment={this.addPayment} removePayment={this.removePayment} onHide={() => this.setState({ visible: false })}/>
				}

				<BPanel header="Factures groupées">

					<Table striped bordered condensed hover responsive>
						<thead>
							<tr>
								<th>#ID</th>
								<th>Partenaire</th>
								<th>Mois</th>
								<th>Montant</th>
								<th>Solde</th>
								<th>&nbsp;</th>
							</tr>
						</thead>
						<tbody>
							{this.state.groupBills && this.state.groupBills.map((bill) =>
								<tr>
									<td>{bill.id_facture} ({bill.reservations.length})</td>
									<td>{(bill.getPartner() && bill.getPartner().displayName()) || 'N/C'}</td>
									<td><Moment format="MM/YYYY">{bill.month}</Moment></td>
									<td>{bill.price}€</td>
									<td>
										{bill.solde > 0 &&
											<Button block bsStyle="warning">{bill.solde}€</Button>
										}
										{bill.solde == 0 &&
											<Button block bsStyle="success">{bill.solde}€</Button>
										}
									</td>
									<td className='text-center'>
										<Button bsStyle="primary" id={bill._id} onClick={this.openModal.bind(this)}>Ouvrir</Button>&nbsp;
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</BPanel>
			</div>
		);
	}
}

GroupBillListPage.propTypes = {
	groupBills: React.PropTypes.array.isRequired,
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/partners/GroupBillList.page.js
 **/